<template>
	<v-row>
		<v-col cols="12">
			<router-link :to="{
				name: 'PesertaPelatihanDetail',
				params: { id: id_pelatihan },
			}">
				<v-btn small color="warning">
					<v-icon small class="mr-2">
						{{ icons.mdiArrowLeft }}
					</v-icon> Kembali</v-btn>
			</router-link>
		</v-col>

		<v-col cols="6">
			<v-card>
				<v-card-text>

					<v-btn v-if="ujian.nilai_akhir == null" color="primary" @click="mulaiTest()">Mulai Post Test</v-btn>
					<div v-else>
						<h3> Nilai Post Test Anda = {{ ujian.nilai_akhir }}</h3>
						<h3>Hasil: <v-chip v-if="ujian.nilai_akhir >= 80" color="success" small>Lulus</v-chip>
							<v-chip v-else color="error" small>Tidak Lulus</v-chip>
						</h3>
						<br>
						<v-btn v-if="ujian.nilai_akhir < 70" color="primary" @click="testUlang()">Ulang Post
							Test</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="6">
			<v-card>
				<v-card-title primary-title>
					Post Test
				</v-card-title>
				<v-card-text>
					<h2 style="text-transform: capitalize;">{{ pelatihan.nama }}</h2>
					<h3>Detail Stakeholder Pelatihan:</h3>
					<div v-html="pelatihan.detail_stakeholder"></div>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<style scoped>
table tr td {
	vertical-align: top;
}

.pdf {
	width: 100%;
	aspect-ratio: 4 / 3;
}

.pdf,
html,
body {
	height: 100%;
	margin: 0;
	padding: 0;
}
</style>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify, mdiPlus, mdiTrashCan, mdiLock, mdiClose, mdiArrowLeft } from '@mdi/js'

export default {
	components: {
	},
	data() {
		return {
			icons: {
				mdiEye,
				mdiPencil,
				mdiMagnify, mdiPlus, mdiTrashCan, mdiLock, mdiClose, mdiArrowLeft
			},
			id_pelatihan: this.$route.params.id_pelatihan,
			pelatihan: {},
			ujian: {},
		}
	},
	watch: {
	},
	computed: {
	},
	created() {
		this.getPelatihan()
		this.getUjian()
	},
	methods: {
		getPelatihan() {
			const fmData = new FormData()
			fmData.append('id_pelatihan', this.id_pelatihan)
			axiosPostAuth('api/Pelatihan/getPelatihan', fmData)
				.then(response => {
					this.pelatihan = Object.assign({}, response.data)
				})
				.catch(error => {
					alert(error)
				})
		},
		getUjian() {
			const fmData = new FormData()
			fmData.append('id_pelatihan', this.id_pelatihan)
			fmData.append('jenis', 'POST TEST')
			axiosPostAuth('api/CBT/getUjian', fmData)
				.then(response => {
					this.ujian = Object.assign({}, response.data)
				})
				.catch(error => {
					alert(error)
				})
		},
		mulaiTest() {
			const fmData = new FormData()
			fmData.append('id_pelatihan', this.id_pelatihan)
			fmData.append('jenis', 'POST TEST')
			axiosPostAuth('api/CBT/addUjian', fmData)
				.then(response => {
					if (response.code === 200) {
						this.$router.push({ name: 'PostTest', params: { id_pelatihan: this.id_pelatihan } })
					}
					else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		testUlang() {
			if (confirm('Apakah yang akan mengulangi Post Test? Nilai anda sebelumnya akan dihapus')) {
				const fmData = new FormData()
				fmData.append('id_ujian', this.ujian.id)
				fmData.append('id_pelatihan', this.id_pelatihan)
				fmData.append('jenis', 'POST TEST')
				axiosPostAuth('api/CBT/hapusUjianUntukMengulangiUjian', fmData)
					.then(response => {
						if (response.code === 200) {
							alert(response.message)
							location.reload();
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		}

	},
}
</script>